import { formatUnits } from '@ethersproject/units'
import { BigNumber } from 'ethers'
import { useGasPrice } from '../providers'

export type GasPrice = ReturnType<typeof useGasPrice>
type DefinedGasPrice = Exclude<GasPrice, undefined>

export function getGasPriceDisplay(gasPrice: GasPrice) {
  if (gasPrice) {
    const { networkGasTip, maxGasTipForEthMax } = gasPrice
    if (maxGasTipForEthMax) {
      return _getGasPriceDisplay(gasPrice, maxGasTipForEthMax)
    }
    if (networkGasTip) {
      return _getGasPriceDisplay(gasPrice, networkGasTip)
    }
  }
  return '-'
}

function _getGasPriceDisplay(gasPrice: DefinedGasPrice, currentGasTip: BigNumber) {
  const speed = getGasPriceSpeed(gasPrice, currentGasTip)
  const { baseFee } = gasPrice
  return baseFee ? `${speed} (${formatGasFee(baseFee)} + Tip: ${formatGasFee(currentGasTip)} Gwei)` : '-'
}

function getGasPriceSpeed(gasPrice: DefinedGasPrice, gasTip: BigNumber) {
  const { averageNetworkGasTip, fastNetworkGasTip } = gasPrice
  if (averageNetworkGasTip && fastNetworkGasTip) {
    if (gasTip.gte(fastNetworkGasTip)) {
      return 'Fast'
    }
    if (gasTip.gte(averageNetworkGasTip)) {
      return 'Average'
    }
    return 'Slow'
  }
  return '-'
}

function formatGasFee(fee: BigNumber) {
  return new Number(formatUnits(fee, 'gwei')).toFixed(2)
}
